import React from 'react'
import cx from 'classnames'
import { connect } from 'react-redux'
import styled from 'styled-components'

export const StyledFlowButton = styled.button`
  border-radius: 100px;
  box-shadow: ${props => props.theme.buttonShadow};
  color: ${props => props.theme.white};
  font-family: ${props => props.theme.gothamSmall};
  font-weight: 700;
  font-size: 18px;
  padding: 20px;
  text-align: center;
  text-transform: uppercase;
  transform: scale(1);
  transition: transform 100ms ease-out;

  width: ${props => props.width || 'auto'};

  &:hover,
  &:focus {
    transform: scale(1.03);
  }
`

export const OrangeFlowButton = styled(StyledFlowButton)`
  &,
  &:hover,
  &:focus {
    background-color: ${props => props.theme.orange};
  }
`

export const BlueFlowButton = styled(StyledFlowButton)`
  &,
  &:hover,
  &:focus {
    background-color: ${props => props.theme.blue};
  }
`

export const WhiteFlowButton = styled(StyledFlowButton)`
  &,
  &:hover,
  &:focus {
    background-color: ${props => props.theme.white};
    color: ${props => props.theme.blue};
  }
`

export const FlowButtonGrid = styled.div`
  display: -ms-grid;
  display: grid;

  -ms-grid-columns: 1fr 170px 1fr 170px 1fr;
  grid-template-columns: 1fr 170px 1fr 170px 1fr;
  grid-template-areas: 'left accept middle decline right';

  > ${StyledFlowButton}:first-of-type {
    -ms-grid-row: 1;
    -ms-grid-column: 2;
    -ms-grid-column-span: 1;
    grid-area: accept;
  }

  > ${StyledFlowButton}:last-of-type {
    -ms-grid-row: 1;
    -ms-grid-column: 4;
    -ms-grid-column-span: 1;
    grid-area: decline;
  }

  @media (max-width: 670px) {
    display: block;
    margin: 0 auto;

    > ${StyledFlowButton}:first-of-type {
      display: block;
    }

    > ${StyledFlowButton}:last-of-type {
      display: block;
      margin-top: 40px;
      margin-bottom: 0;
    }
  }
`

const FlowButton = ({
  dispatch,
  className,
  children,
  as = 'button',
  Tag = as,
  blue = false,
  ...props
}) => (
  <Tag
    className={cx('flow__button', { 'flow__button--alt': !blue }, className)}
    {...props}
    onFocus={e => {
      dispatch({
        type: '@@redux-form/FOCUS',
        meta: {
          field: e.currentTarget.id
        }
      })
      if (typeof props.onFocus === 'function') {
        props.onFocus(e)
      }
    }}>
    {children}
  </Tag>
)

export default connect()(FlowButton)
